import { Component, ElementRef, Input, ViewChild, AfterViewInit, inject } from "@angular/core";

import { ShellService } from "@tylertech/incode-module";

const defaultDiameter = "20";
const defaultStroke = "10";

@Component({
    selector: "busy-indicator",
    templateUrl: "./busyIndicator.tmpl.html",
    styleUrls: [
        "./busyIndicator.component.scss",
    ],
    standalone: false
})
export class BusyIndicatorComponent implements AfterViewInit
{
    private readonly $shellService = inject(ShellService);

    /** @deprecated - big was only used to control the diameter, which is no longer supported by the forge component */
    @Input() readonly big: boolean;
    @Input() readonly overlay: boolean;

    // TODO - card, chart, and page are a mutually exclusive set (along with a none element) replace with string literal types and single input...
    @Input() readonly card: boolean;
    @Input() readonly chart: boolean;
    @Input() readonly page: boolean;

    @Input() readonly message: string;
    @Input() readonly dialog: boolean = false;

    @ViewChild("busyIndicatorCard") readonly busyIndicatorCard: ElementRef;

    ngAfterViewInit()
    {
        if (this.busyIndicatorCard)
        {
            const cardWidth = this.busyIndicatorCard.nativeElement.scrollWidth / 2;
            const vw = window.innerWidth / 2;
            this.busyIndicatorCard.nativeElement.style.left = `${vw - cardWidth}px`;
        }
    }

    // TODO - convert to computed signal
    get progressSpinnerClasses(): Record<string, boolean>
    {
        /* eslint-disable @typescript-eslint/naming-convention */
        return {
            "page-progress": this.page,
            "busy-dialog": this.dialog
        };
        /* eslint-enable @typescript-eslint/naming-convention */
    }

    // TODO - convert to signal
    get spinnerOverLayClasses(): Record<string, boolean>
    {
        /* eslint-disable @typescript-eslint/naming-convention */
        return {
            "spinner-overlay-offset": !this.$shellService.isEmbedded(),
            "busy-dialog": this.dialog
        };
        /* eslint-enable @typescript-eslint/naming-convention */
    }

    /**
     * TODO - forge.CircularProgressComponent doesn't define attributes for diameter or stroke-width
     * @deprecated
     */
    get diameter(): string
    {
        if (this.page)
        {
            return "75";
        }
        else if (this.big)
        {
            return "40";
        }
        else
        {
            return defaultDiameter;
        }
    }

    /**
     * TODO - forge.CircularProgressComponent doesn't define attributes for diameter or stroke-width
     * @deprecated
     */
    get stroke(): string
    {
        if (this.page)
        {
            return defaultStroke;
        }
        else if (this.big)
        {
            return "7";
        }
        else
        {
            return "5";
        }
    }
}
